import { useEffect, useState } from 'react';
import { moduleClientFactory } from '../../../api-service/module-client-factory';

const client = moduleClientFactory.createForumCaseworkerClient();

export interface IForumCaseworkerContext {
  canAdministerNews: boolean;
  canRenameChatAttachments: boolean;
  canDeleteChatMessages: boolean;
  canManageAbsenceOfOtherCaseworkers: boolean;
  isChatFileUploadEnabled: boolean;
  displayName: string;
  isNewsFileUploadEnabled: boolean;
  isFeedbackEnabled: boolean;
}

const allowsNothing: IForumCaseworkerContext = {
  canAdministerNews: false,
  canRenameChatAttachments: false,
  canDeleteChatMessages: false,
  canManageAbsenceOfOtherCaseworkers: false,
  isChatFileUploadEnabled: false,
  displayName: '',
  isNewsFileUploadEnabled: false,
  isFeedbackEnabled: false,
};

export function useForumCaseworkerContext(): IForumCaseworkerContext {
  const [context, setContext] = useState(allowsNothing);

  useEffect(() => {
    client
      .getContext()
      .then(result =>
        setContext({
          canAdministerNews: result.canAdministerNews,
          canRenameChatAttachments: result.canRenameChatAttachments,
          canDeleteChatMessages: result.canDeleteChatMessages,
          canManageAbsenceOfOtherCaseworkers: result.canManageAbsenceOfOtherCaseworkers,
          isChatFileUploadEnabled: result.context?.addons?.isFileUploadEnabled ?? false,
          displayName: result.context?.displayName ?? '',
          isNewsFileUploadEnabled: result.context?.addons?.isFileUploadEnabledForNewsItems ?? false,
          isFeedbackEnabled: result.context?.addons?.isFeedbackEnabled ?? false,
        })
      )
      .catch(() => setContext(allowsNothing));
  }, []);

  return context;
}
